import React from 'react';
import { TextField } from '@mui/material';

export const Number = React.forwardRef(
  ({ label, maxWidth, maxLength = 140, ...props }, ref) => (
    <TextField
      label={label}
      variant="outlined"
      type="number"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      onInput={({ target }) => {
        const inputValue = target.value;
        target.value = inputValue.replace(/\D/g, '').substring(0, 6);
      }}
      inputProps={{
        pattern: '[0-9]*',
        inputMode: 'numeric',
        maxLength,
        ref,
      }}
      {...props}
    />
  )
);

Number.displayName = 'Number';
